export const CRONOFY = 'cronofy';
